import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import {Router, RouterLink} from '@angular/router';
import {Client, ClientService} from '@app/admin/client.service';
import {PreferencesService} from '@app/preferences/preferences.service';
import {SiteConfig, SiteConfigService} from '@app/shared/site-config.service';
import {Observable} from 'rxjs';
import {mergeMap, reduce, tap} from 'rxjs/operators';
import {WorkspaceButtonComponent} from '../workspace-button/workspace-button.component';

@Component({
    selector: 'frog-workspace-list',
    templateUrl: './workspace-list.component.html',
    styleUrls: ['./workspace-list.component.scss'],
    imports: [WorkspaceButtonComponent, MatIconButton, MatTooltip, RouterLink, MatIcon, AsyncPipe],
})
export class WorkspaceListComponent implements OnInit {
    public clients$: Observable<Client[]>;
    public siteConfig$: Observable<SiteConfig>;

    constructor(
        private clientService: ClientService,
        private siteconfigService: SiteConfigService,
        private preferencesService: PreferencesService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.clients$ = this.clientService.getClients();
        this.siteConfig$ = this.siteconfigService.siteConfig;
    }

    setClient(client: string) {
        this.clientService
            .setClient(client)
            .pipe(
                mergeMap(() => this.siteconfigService.get()),
                tap(() => this.preferencesService.getPreferences()),
                reduce((acc, value) => acc),
            )
            .subscribe((siteConfig) => {
                this.router.navigate(['/s', siteConfig.data.primary_stream]);
            });
    }
}
